import type { Preload } from './quickload.types';

// a global object for caching preload results
export const preloadsHash: Record<string, Preload> = {};
